import { configureStore } from "@reduxjs/toolkit";
import cartSlice, { cartMiddleware } from "./features/cart/cartSlice";
import productsReducer from "./products/productsSlice"
import userReducer from "./user/userSlice";

export const store = configureStore({
  reducer: {
    cart: cartSlice,
    products: productsReducer,
    user: userReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(cartMiddleware),
});
